import { baseApi, decodeProductExtensionEnvelope, resourceScopeTag, resourceTag, type ProductExtensionEnvelope } from '@krp/client-runtime'

import { AQSI_TAG_TYPES, AQSI_TAGS } from '../../../shared/api/tags'
import { AQSI_URLS } from '../../../shared/api/urls'

/** Вид, который служба AQSI пишет в `kind` конверта расширения. */
export const AQSI_EXTENSION_KIND = 'aqsi'

export interface AqsiProductExtensionArgs {
  resourceId: string
  goodId: string
}

/**
 * Расширение карточки AQSI в ОБЩЕМ `baseApi`. Тег карточки тот же, что у окна товара AQSI: правка карточки в кабинете
 * перечитывает и расширение.
 */
export const aqsiProductExtensionApi = baseApi.enhanceEndpoints({ addTagTypes: AQSI_TAG_TYPES }).injectEndpoints({
  endpoints: (build) => ({
    aqsiProductExtension: build.query<ProductExtensionEnvelope, AqsiProductExtensionArgs>({
      query: ({ resourceId, goodId }) => ({
        url: AQSI_URLS.goodExtension(resourceId, goodId),
        decode: decodeProductExtensionEnvelope(AQSI_EXTENSION_KIND),
      }),
      providesTags: (_result, _error, { resourceId, goodId }) => [
        resourceTag(AQSI_TAGS.goods, resourceId, `card-${goodId}`),
        resourceScopeTag(resourceId),
      ],
    }),
  }),
})

export const { aqsiProductExtension } = aqsiProductExtensionApi.endpoints
